import { EmptyState } from "@components/empty-state";
import { FlexLoader } from "@components/loader";
import { Config } from "@components/table";
import styles from "./rowTable.module.scss";
import classNames from "classnames";

type Props<T extends Record<string, unknown>> = {
  config: Config<T>;
  data?: T | null;
  className?: string;
  loading?: boolean;
};

export const RowTable = <T extends Record<string, unknown>>({
  config,
  data,
  className,
  loading,
}: Props<T>) => {
  return loading ? (
    <FlexLoader />
  ) : data == null ? (
    <EmptyState text={"Ничего не найдено"} />
  ) : (
    <table className={classNames(styles.main, className)}>
      <tbody>
        {config.map((column, colIndex) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const cellData = data[column.source] as any;
          return (
            <tr
              key={colIndex}
              className={styles.row}
              style={
                typeof column.visible == "boolean"
                  ? column.visible === false
                    ? { display: "none" }
                    : {}
                  : typeof column.visible == "function"
                    ? column.visible(cellData, data)
                      ? {}
                      : { display: "none" }
                    : {}
              }
            >
              <td className={styles.cellTitle}>{column.label}</td>
              <td className={styles.cellData}>
                {column.renderComponent?.(cellData, data) ?? cellData}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
